<template>
  <Layout>
    <div class="section  content is-size-7">
      <p class="is-size-6">ABO VERWALTUNG</p>
      <p>Sie wollen sich Abmelden? Bitte senden Sie dazu eine Email an: businessfleet.at@silverlines.info<br>
        Bitte vergessen Sie nicht ihre Handynummer anzugeben. Wir werden ihnen schnellstmöglich antworten.<br>
        Hotline:         Telefon: <a href="tel:0800100299">0800100299</a><br>
<br>
        <br>
        A1 Kunden klicken Sie bitte hier www.a1.net/meina1<br>
        T-Mobile Kunden klicken Sie bitte hier http://www.t-mobile.at/zahlungsdienste<br>
        Tele.Ring Kunden klicken Sie bitte hier http://www.telering.at/zahlungsdienste<br>
        <br>
        Sie können aber auch unser Online-Tool nutzen, tragen Sie dafür Ihre Handynummer in das unten angegebene Feld ein. Anschließend können Sie Ihr Abo eigenständig kündigen.

      </p>
      <p v-if="state === 'open'" class="has-text-centered"><button class="button p-l-lg p-r-lg" @click="cancel">Kündigen</button></p>
      <p v-else-if="state === 'closed'">Session wird geschlossen</p>
      <p v-else-if="state === 'already_closed'">Session ist geschlossen.</p>
      <p v-else-if="state === 'valid'">Session ist geschlossen.</p>
      <p v-else-if="state === 'wait'">Bitte warten.</p>
      <p v-else>Session wird geschlossen.</p>
    </div>
  </Layout>
</template>

<script>
import axios from 'axios'
import Layout from '@/layouts/Kyf'

export default {
  name: 'Deactivation',
  data() {
    return {
      saleId: null,
      state: 'wait'
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const saleId = window.localStorage.getItem('saleId') 
      const res = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ saleId }`)
        .catch(() => { return { data: { state: 'error' } } })
      this.saleId = saleId
      this.state = res.data.state
    } else {
      return {
        saleId: null,
        state: 'unknown'
      }
    }
  },
  methods: {
    async cancel () {
      const res = await axios.get(`/${ this.$store.getters.apiPrefix }/closeSale/${ this.saleId }`)
        .catch(() => { return { data: { state: 'error' } } })
      this.state = res.data.state
    }
  },
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/AT/Deactivation.vue